import { Routes, Route } from "react-router-dom";

import ProjectsListSection from "./sections/projectsListSection";
import ProjectInfoSection from "./sections/projectInfoSection";
import ProjectRoutesSection from "./sections/projectRoutesSection";
import ProjectVacancySection from "./sections/projectVacancySection";

function ProjectsApp() {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <Routes>
            {!data.isCustomer && (
                <>
                    <Route path="/" element={<ProjectsListSection />} />
                    <Route path='/:id/info' element={<ProjectInfoSection />} />
                    <Route path='/:id/routes' element={<ProjectRoutesSection />} />
                    <Route path='/:id/vacancy' element={<ProjectVacancySection />} />
                </>
            )}
        </Routes>
    );
}

export default ProjectsApp;
